import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  $,
  r,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/visually-hidden/visually-hidden.ts
var FadvVisuallyHidden = class extends s {
  render() {
    return $`<slot></slot>`;
  }
};
FadvVisuallyHidden.styles = r` ${component_styles_default} :host(:not(:focus-within)) { position: absolute !important; width: 1px !important; height: 1px !important; clip: rect(0 0 0 0) !important; clip-path: inset(50%) !important; border: none !important; overflow: hidden !important; white-space: nowrap !important; padding: 0 !important; } `;
FadvVisuallyHidden = __decorateClass([
  n("fadv-visually-hidden")
], FadvVisuallyHidden);

export {
  FadvVisuallyHidden
};
